export default __webpack_public_path__ + "static/media/company-image.743bbc8d.jpg";